import {Component, Inject, OnInit} from '@angular/core';
import {LoadingController, ModalController, NavController} from '@ionic/angular';
import {ValidateProductModalComponent} from '../../../modal/validate-product-modal/validate-product-modal.component';
import {SearchModalComponent} from '../../../modal/search-modal/search-modal.component';
import {CouleurModalComponent} from '../../../modal/couleur-modal/couleur-modal.component';
import {ToastService} from '../../../services/toast.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {QrcodeProcessPage} from '../qrcode-process.page';
import {ApiService} from '../../../services/api.service';

import * as moment from 'moment';
declare var $;

@Component({
  selector: 'app-product',
  templateUrl: './product.page.html',
  styleUrls: ['./product.page.scss'],
})
export class ProductPage implements OnInit {
  qrcode: any;
  products: any;
  productForm: FormGroup;
  currentUser: any;
  seeall = false;


  constructor(@Inject(QrcodeProcessPage) private parent: QrcodeProcessPage, private navController: NavController, private apiService: ApiService, private loadingController: LoadingController, private toastService: ToastService, private modalController: ModalController) {
    this.qrcode = this.parent.qrcode;
    this.products = this.parent.product;

    this.currentUser = this.apiService.authApi.currentUser;
  }

  changeSee(){
    this.seeall = !this.seeall;
  }

  ngOnInit() {

    if (this.currentUser.status != 3){
      this.productForm = new FormGroup({
        type: new FormControl('', Validators.compose([Validators.required])),
        type_name: new FormControl('', Validators.compose([Validators.required])),
        marque: new FormControl('', Validators.compose([Validators.required, Validators.minLength(2)])),
        modele: new FormControl('', Validators.compose([Validators.required, Validators.minLength(2)])),
        couleur: new FormControl('', Validators.compose([Validators.required, Validators.minLength(2)])),

        origin: new FormControl('', Validators.compose([Validators.required])),

        serialNumber: new FormControl(''),
        orderNumber: new FormControl(''),
        motorNumber: new FormControl(''),
        invoiceNumber: new FormControl(''),
        batteryNumber: new FormControl(''),
        price: new FormControl('',
            (this.currentUser.activeInsurance == 1) ?
              Validators.compose([Validators.pattern('^[0-9]+(\\,[0-9][0-9]?)?$'), Validators.required])
        : Validators.compose([Validators.pattern('^[0-9]+(\\,[0-9][0-9]?)?$')])),
        comment: new FormControl(''),
        buyAt: new FormControl(''),

        facture: new FormControl(''),
        photo: new FormControl('')
      });
    }
    else{
      this.productForm = new FormGroup({
        type: new FormControl('', Validators.compose([])),
        type_name: new FormControl('', Validators.compose([])),
        marque: new FormControl('', Validators.compose([Validators.minLength(3)])),
        modele: new FormControl('', Validators.compose([Validators.minLength(3)])),
        couleur: new FormControl('', Validators.compose([Validators.minLength(3)])),

        origin: new FormControl(''),

        serialNumber: new FormControl(''),
        orderNumber: new FormControl(''),
        motorNumber: new FormControl(''),
        batteryNumber: new FormControl(''),
        invoiceNumber: new FormControl(''),
        price: new FormControl('', Validators.compose([Validators.pattern('^[0-9]+(\\,[0-9][0-9]?)?$')])),
        comment: new FormControl(''),
        buyAt: new FormControl(''),

        facture: new FormControl(''),
        photo: new FormControl('')
      });
    }


    if (this.products){
      this.productForm.controls.type.setValue(this.products.main_type === 'vae' ? 'electrique' : this.products.main_type === 'velo' ? 'non electrique' : this.products.main_type);
      this.productForm.controls.type_name.setValue(this.products.type_name);
      this.productForm.controls.marque.setValue(this.products.brand_name);
      this.productForm.controls.modele.setValue(this.products.brand_model);
      this.productForm.controls.couleur.setValue(this.products.color);

      this.productForm.controls.origin.setValue(this.products.origin);

      this.productForm.controls.serialNumber.setValue(this.products.serial_number);
      this.productForm.controls.orderNumber.setValue(this.products.order_number);
      this.productForm.controls.motorNumber.setValue(this.products.motor_number);
      this.productForm.controls.batteryNumber.setValue(this.products.battery_number);
      this.productForm.controls.price.setValue(this.products.price?.replace('.', ','));
      this.productForm.controls.comment.setValue(this.products.comment);
      this.productForm.controls.buyAt.setValue(this.products.buy_it);

      this.productForm.controls.facture.setValue(this.products.facture);
      this.productForm.controls.photo.setValue(this.products.image);
      this.productForm.controls.invoiceNumber.setValue(this.products.invoice_number);
      if (this.productForm.controls.origin.value == null){
        this.productForm.controls.origin.setValue(this.currentUser.defaultOrigin);
      }
    } else {
      if (this.currentUser != 3){
        this.productForm.controls.origin.setValue(this.currentUser.defaultOrigin);
      }
    }

    if (this.productForm.controls.origin.value == null){
      this.productForm.controls.origin.setValue('Neuf');
    }
  }


  async doAction(){
    if (this.productForm.invalid) {
      this.productForm.markAllAsTouched();
      if (this.productForm.controls.type.value == null){
        $('.select_type_error').attr('style', 'display:block');
      }
      if (this.productForm.controls.origin.value == null){
        $('.select_origin_error').attr('style', 'display:block');
      }
      return;
    }

    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();

    const d: any = {
      paravol_number : this.qrcode,
      product_type : this.productForm.controls.type.value,
      type_name : this.productForm.controls.type_name.value,
      brand_name : this.productForm.controls.marque.value,
      brand_model : this.productForm.controls.modele.value,
      color : this.productForm.controls.couleur.value,

      origin : this.productForm.controls.origin.value,

      serial_number : this.productForm.controls.serialNumber.value,
      order_number : this.productForm.controls.orderNumber.value,
      motor_number : this.productForm.controls.motorNumber.value,
      battery_number : this.productForm.controls.batteryNumber.value,
      invoice_number : this.productForm.controls.invoiceNumber.value,
      price : this.productForm.controls.price.value?.replace(',', '.'),
      comment : this.productForm.controls.comment.value,
      buy_it : this.productForm.controls.buyAt.value
    };

    if (this.productForm.controls.photo.value){
      d.image_id = this.productForm.controls.photo.value.id;
    }
    else{
      d.image_id = null;
    }

    if (this.productForm.controls.facture.value){
      d.facture_id = this.productForm.controls.facture.value.id;
    }
    else{
      d.facture_id = null;
    }

    this.apiService.qrcodeApi.post(d).then((e: any) => {
      loading.dismiss();

      this.parent.product = e;


      if (this.currentUser.status == 3){
        this.navController.navigateBack('/home');
        this.toastService.success('Les informations ont bien été sauvegardé.');
      }
      else{
        this.navController.navigateForward('/home/' + this.qrcode + '/transfer');
      }
    }).catch(() => {
      this.toastService.error('Modification des données du propriétaire impossible. Vérifiez les informations saisies');
      loading.dismiss();
    });
  }


  changeType(value){
    this.productForm.controls.type.setValue(value);
    $('.select_type_error').attr('style', 'display:none');
  }

  changeOrigin(value){
    this.productForm.controls.origin.setValue(value);
    $('.select_origin_error').attr('style', 'display:none');
  }


  quit(){
    this.navController.navigateBack('/home');
  }



  async testToast(){
      const loading = await this.loadingController.create({
        spinner: 'circular'
      });

      loading.present();

      setTimeout(() => {
        this.toastService.success('Elèment ajouté avec succés.');
        loading.dismiss();
      }, 2000);
  }


  doSomething() {
     this.productForm.controls.buyAt.setValue(moment(this.productForm.controls.buyAt.value).format('YYYY-MM-DD')); // 2019-04-22
  }



  async openCouleurModal(){
    const modal = await this.modalController.create({
      component: CouleurModalComponent,
      cssClass: 'couleurModalComponent',
      componentProps: {
        couleurs: this.productForm.controls.couleur.value,
      }
    });

    modal.onDidDismiss().then((res) => {
      if (res.data){
        this.productForm.controls.couleur.setValue(res.data);
      }
    });

    return await modal.present();
  }

  async openMarqueModal(){
    const modal = await this.modalController.create({
      component: SearchModalComponent,
      cssClass: 'searchModalComponent',
      componentProps: {
        type: 'Marque',
        value : this.productForm.controls.marque.value,
      }
    });

    modal.onDidDismiss().then((res) => {
      if (res.data || res.data === ''){
        this.productForm.controls.marque.setValue(res.data);
      }
    });

    return await modal.present();
  }

  async openTypeNameModal(){
    const modal = await this.modalController.create({
      component: SearchModalComponent,
      cssClass: 'searchModalComponent',
      componentProps: {
        type: 'Type',
        value : this.productForm.controls.type_name.value,
      }
    });

    modal.onDidDismiss().then((res) => {
      if (res.data || res.data === ''){
        this.productForm.controls.type_name.setValue(res.data);
      }
    });

    return await modal.present();
  }


  async openModeleModal(){
    const modal = await this.modalController.create({
      component: SearchModalComponent,
      cssClass: 'searchModalComponent',
      componentProps: {
        type: 'Modèle',
        value : this.productForm.controls.modele.value,
        marque : this.productForm.controls.marque.value
      }
    });

    modal.onDidDismiss().then((res) => {
      if (res.data || res.data === ''){
        this.productForm.controls.modele.setValue(res.data);
      }
    });

    return await modal.present();
  }

}
